"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
exports.useStyles = (0, makeStyles_1.default)((theme) => ({
    item: {
        padding: '2pt 0',
        fontFamily: theme.typography.fontFamily,
    },
    itemSelected: {
        backgroundColor: theme.palette.grey[300],
    },
    itemFocused: {
        backgroundColor: theme.palette.highlight,
    },
}));
//# sourceMappingURL=infinite-list-styles.js.map